import { LifeCyclePolicy } from '../contracts/lifecycles';
import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

export const useLifeCyclePolicy = (mspId: string, customerId: string) => {
  return useAPIQuery(['getLifeCyclePolicy', mspId, customerId], async client => {
    const response = await client.lifeCyclePolicy.getPolicy({
      params: {
        mspId,
        customerId
      }
    });

    if (response.status === 400) return null;

    if (response.status !== 200) throw APIError.fromResponse(response);

    return response.body;
  });
};

export const useCreateLifeCyclePolicy = (mspId: string, customerId: string) => {
  return useAPIMutation((client, query) => {
    return async ({ ...args }: LifeCyclePolicy) => {
      const response = await client.lifeCyclePolicy.postPolicy({
        body: { ...args },
        params: { mspId, customerId }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      await query.invalidateQueries(['getLifeCyclePolicy', mspId, customerId]);
      return response.body;
    };
  });
};

export const useUpdateLifeCyclePolicy = (mspId: string, customerId: string) => {
  return useAPIMutation((client, query) => {
    return async ({ ...args }: LifeCyclePolicy) => {
      const response = await client.lifeCyclePolicy.putPolicy({
        body: { ...args },
        params: { mspId, customerId }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      await query.invalidateQueries(['getLifeCyclePolicy', mspId, customerId]);
      return response.body;
    };
  });
};
